import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

export const SearchDescriptionText = styled(Text14)``;

SearchDescriptionText.defaultProps = {
  themeColor: ThemeColorType.gray,
};

export const SearchDescriptionWrapper = styled.div`
  margin: 20px 0;
`;
